import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconPlusThin = ({ className = '', color = '#222', height = 9, title, width = 9 }: Icon) => (
    <AccessibleSVG
        className={`icon-plus-thin ${className}`}
        height={height}
        title={title}
        viewBox="0 0 9 9"
        width={width}
    >
        <path className="fill-color" d="M5 4V0H4v4H0v1h4v4h1V5h4V4H5z" fill={color} fillRule="evenodd" />
    </AccessibleSVG>
);

export default IconPlusThin;
